import {
  appInfo,
  appRestart,
  appsList,
  appTouch,
  uploadLog,
  appRequestExternalSynchronization,
  appRetryOrchestratorProcess,
  appSetOrchestratorPhone,
  appSendOrchestratorArchive,
  appSendOkvedDecision,
  getPersons,
  getTasksWithHistory
} from "@/api";

import formatDateFilter from "@/utils/formatDateFilter";

const initState = () => ({
  apps: [],
  appCompany: {},
  appId: null,
  files: [],

  logs: [],
  fl: [],

  tasks: [],

  page: 1,
  pageSize: 15,
  total: null,
  filter: [],
  search_query: "",

  showApp: false,

  attachments: []
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    fl: (state) => state.fl,
    countDocs: (state) => {
      let numOfDocs = 0;

      state.fl.forEach((item) => {
        numOfDocs = item.docs ? numOfDocs + item.docs.length : numOfDocs;
      });

      console.log("numOfDocs: ", numOfDocs);

      return numOfDocs;
    },
    extra: (state) => {
      return state.appCompany.extra;
    },
    sourceState: (state) => state.appCompany.extra?.state_data?.source_state,
    attachments: (state) => state.attachments,
    logList: (state) => {
      return state.logs.step_logs;
    },
    model: (state) => {
      return state.logs.model;
    },
    dateFilter: (state) => {
      const filter = state.filter.find((f) => f.field === "dadd");
      return formatDateFilter(filter)
    },
  },

  mutations: {
    set: (state, payload) => (state[payload.type] = payload.value),
    setAppsList: (state, payload) => (state.apps = payload),
    setAppInfo: (state, payload) => {
      state.appCompany = payload;

      state.attachments = state.appCompany.extra?.attachments;
    },
    openAppCompany: (state, payload) => (state.showApp = payload),
    setId: (state, payload) => (state.appId = payload),

    setPage: (state, payload) => (state.page = payload),
    setPageSize: (state, payload) => (state.pageSize = payload),
    setTotal: (state, payload) => (state.total = payload),
    setSearchQuery: (state, payload) => (state.search_query = payload),
    setAttachmentListFiles: (state, { groupName, name, value }) => {
      let attachments = state.attachments;

      const groupAttachmentsIndex = attachments?.findIndex(item => item.name === groupName);
      if (groupAttachmentsIndex !== -1)
      {
        let attachmentsList = attachments[groupAttachmentsIndex].list;

        const attachmentListIndex = attachmentsList?.findIndex(item => item.name === name);
        if (attachmentListIndex !== -1) {
          attachmentsList[attachmentListIndex].files = value;
        }
      }
    },

    setDateFilter: (state, payload) => {
      state.filter = state.filter.filter(({ field }) => field !== "dadd");

      const daddFilter = {
        field: "dadd",
        logic: "and",
        filters: [],
      };

      if (payload.start) {
        daddFilter.filters.push({
          operator: "gte",
          value: payload.start,
        });
      }
      if (payload.end) {
        daddFilter.filters.push({
          operator: "lte",
          value: payload.end,
        });
      }

      if (daddFilter.filters.length > 0) {
        state.filter.push(daddFilter);
      }
    },
    setFl: (state, payload) => (state.fl = payload),
    setTasks: (state, payload) => (state.tasks = Array.isArray(payload) ? payload : []),
    setFlDocsFor: (state, payload) => {
      state.fl[payload.index].attachments = payload.docs;
    },

    setLogs: (state, payload) => (state.logs = payload),
    reset: (state) => {
      const initialState = initState();
      Object.keys(initialState).forEach((key) => (state[key] = initialState[key]));
    },
  },
  actions: {
    async appsList({ commit, state: { page, pageSize, filter, search_query } }) {
      const response = await appsList({
        page,
        pageSize,
        filter,
        search_query,
      });
      if (response) {
        commit("setAppsList", response.list || []);
        commit("setTotal", response.total);
      }
      return response;
    },

    async appInfo({ commit }, id) {
      const response = await appInfo({ id: id });
      if (response) {
        commit("setAppInfo", response);
        commit("openAppCompany", true);
        commit("setId", id);
        //commit("setFl", response.templatedata?.fl || []);
      }
      return response;
    },

    async fetchAppPersons({ commit, state }) {
      if (!state.appId) return;

      const response = await getPersons(state.appId);
      commit("setFl", response || []);
    },

    async fetchTasksWithHistory({ commit, state }) {
      if (!state.appId) return;

      const response = await getTasksWithHistory(state.appId);
      commit("setTasks", response);
    },

    async appTouch({state}, data) {
      return await appTouch({id: state.appId, data});
    },

    async uploadLog({ commit, state }) {
      const response = await uploadLog({ id: state.appId });
      if (response) {
        commit("setLogs", response);
      }
      return response;
    },

    async appRestart({ state }, { stop_reason, options, selected_options }) {
      const res = await appRestart({ id: state.appId, stop_reason, options, selected_options });
      return res;
    },

    async appRequestExternalSynchronization({ state }, type) {
      const res = await appRequestExternalSynchronization({ id: state.appId, type });
      return res;
    },

    async appRetryOrchestratorProcess({ state }) {
      const res = await appRetryOrchestratorProcess({ id: state.appId });
      return res;
    },

    async appSetOrchestratorPhone({ state }, phoneNumber) {
      const res = await appSetOrchestratorPhone({ id: state.appId, phoneNumber });
      return res;
    },

    async appSendOrchestratorArchive({ state }) {
      const res = await appSendOrchestratorArchive({ id: state.appId });
      return res;
    },

    async appSendOkvedDecision({ state }, decision) {
      const res = await appSendOkvedDecision({ id: state.appId, decision });
      return res;
    },

    //  сброс после закрытие sidePanel
    resetAppCompany({ commit }) {
      commit("setAppInfo", {});
      commit("setLogs", []);
      commit("set", { type: "fl", value: [] });
    },
  },
};
